<template>
  <section>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
     <v-list dense color="transparent" class="menu-footer">
            <v-list-item link to="/en/services">
              <v-list-item-content>
                <v-list-item-title>Services</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/en/us">
              <v-list-item-content>
                <v-list-item-title>About us</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/en/blog">
              <v-list-item-content>
                <v-list-item-title>Blog</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link to="/en/contact">
              <v-list-item-content>
                <v-list-item-title>Contact us</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
    </v-navigation-drawer>
    <v-app-bar class="bg-menu" flat dark>
      <v-app-bar-nav-icon v-if="small" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-spacer v-if="small"></v-spacer>
      <v-spacer v-if="!small"></v-spacer>
      <v-toolbar-title class="ml-2"><v-btn to="/es" text tile large><img src="@/assets/logo_small.svg" class="logo" alt="PérezBrown" ></v-btn></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text dark tile v-if="!small" to="/en/services">Services</v-btn>
      <v-btn text dark tile v-if="!small" to="/en/us">About us</v-btn>
      <v-btn text dark tile v-if="!small" to="/en/blog">Blog</v-btn>
      <v-btn text dark tile v-if="!small" to="/en/contact">Contact us</v-btn>
      <div class="ml-5">
        <v-btn text color="secondary" class="lang" x-small tile to="/es">Es</v-btn>/
        <v-btn text color="secondary" class="lang" dark x-small tile to="/en">En</v-btn>
      </div>
      <v-spacer v-if="!small"></v-spacer>
    </v-app-bar>
    <v-container fluid class="ma-0 pa-0">
      <v-row align-content="center" justify="center" class="ma-0">
        <v-col cols="12" align="center" justify="center" class="ma-0 pa-0">
          <router-view :key="$route.fullPath" v-if="time"/>
        </v-col>
      </v-row>
    </v-container>
    <footeren/>
  </section>
</template>

<script>
import FooterEn from './FooterEn';
export default {
  components: {
    'footeren': FooterEn
  },
  data() {
    return {
      drawer: false,
      small: false,
      time: false,
    };
  },
  mounted() {
    this.getWindowWidth();
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
    });
    setTimeout(() => { this.time = true}, 200);
  },
  methods: {
    getWindowWidth() {
      const width = window.innerWidth;
      if(width<820){
        this.small = true;
      } else {
        this.small = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./Menu.scss";
</style>
